import { Button } from '@/components';
import { Icon } from '@/components/icon';
import type { FC } from 'react';
import { useReviewMeterModal } from './ReviewMeterModal';
import type { PopulatedCombinedMeter } from '@/lib/services';

interface MeterReviewButtonProps {
  meter: PopulatedCombinedMeter;
}

export const MeterReviewButton: FC<MeterReviewButtonProps> = ({ meter }) => {
  const {
    Modal: ReviewMeterModal,
    closeModal: closeReviewMeterModal,
    openModal: openReviewMeterModal,
    isOpen: isOpenReviewMeterModal,
  } = useReviewMeterModal();

  return (
    <>
      <Button icon={<Icon iconString="eye" />} type="primary" onClick={openReviewMeterModal}>
        Review
      </Button>

      <ReviewMeterModal isOpen={isOpenReviewMeterModal} meter={meter} onClose={closeReviewMeterModal} />
    </>
  );
};
